import { useEffect, useState } from "react";

const useRefinancePageData = () => {
  const jsonPath = process.env.REACT_APP_CDN + "refinance/jsons/refinancePage.json";
  const [refinancePageData, setRefinancePageData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetch(jsonPath);
        const jsonData = await data.json();
        setRefinancePageData(jsonData);
      } catch (err) {
        console.log("Error Fetching Refinance Json data", err);
      }
    };

    fetchData();
  }, [jsonPath]); 

  return refinancePageData;
};

export default useRefinancePageData;
